import React from 'react';
import ReactCookieBanner from 'react-cookie-banner';
import styled from 'styled-components';
import Theme from '../modules/Theme';
var cookieMessage = 'Cookies help us deliver our services. By using our ' + ' services, you agree to our use of cookies.';
var LearnMore = styled(function (_ref) {
  var className = _ref.className,
      fullPath = _ref.fullPath;
  var href = fullPath ? 'https://www.alces-flight.com/privacy' : '/privacy';
  return /*#__PURE__*/React.createElement("a", {
    className: className,
    href: href
  }, "Learn more");
}).withConfig({
  displayName: "CookieBanner__LearnMore",
  componentId: "j6rwx1-0"
})(["color:", ";margin-left:0.5rem;text-decoration:none;"], Theme.primary);

var CookieBanner = function CookieBanner(_ref2) {
  var fullPath = _ref2.fullPath;
  return /*#__PURE__*/React.createElement(ReactCookieBanner, {
    dismissOnScroll: false,
    link: /*#__PURE__*/React.createElement(LearnMore, {
      fullPath: fullPath
    }),
    message: cookieMessage,
    styles: {
      banner: {
        backgroundColor: 'rgba(52, 152, 219, 0.8)',
        position: 'fixed',
        bottom: '41px',
        padding: '10px 100px',
        height: 'auto',
        lineHeight: 'auto'
      },
      message: {
        color: 'black',
        textShadow: '0 0 10px white, 0 0 10px white, 0 0 10px white, 0 0 10px white',
        fontWeight: 'bold',
        lineHeight: 'auto',
        fontSize: '24px'
      }
    }
  });
};

export default CookieBanner;